import { Routes, Route, Navigate } from 'react-router-dom'
import AppShell from './components/layout/AppShell.jsx'
import RequireAuth from './lib/auth/RequireAuth.jsx'
import LoginPage from './routes/LoginPage.jsx'
import DashboardPage from './routes/DashboardPage.jsx'
import OrganizationsPage from './routes/OrganizationsPage.jsx'
import OrganizationDetailPage from './routes/OrganizationDetailPage.jsx'
import SpacesPage from './routes/SpacesPage.jsx'
import SiteDetailPage from './routes/SiteDetailPage.jsx'
import FloorWorkspacePage from './routes/FloorWorkspacePage.jsx'
import AssetsPage from './routes/AssetsPage.jsx'
import SettingsPage from './routes/SettingsPage.jsx'
import NotFoundPage from './routes/NotFoundPage.jsx'

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/organizations" element={<OrganizationsPage />} />
        <Route path="/organizations/:orgId" element={<OrganizationDetailPage />} />
        <Route path="/spaces" element={<SpacesPage />} />
        <Route path="/spaces/sites/:siteId" element={<SiteDetailPage />} />
        <Route path="/spaces/floors/:floorId" element={<FloorWorkspacePage />} />
        <Route path="/assets" element={<AssetsPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  )
}
